var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"text-center inner"},[_vm._t("heading-title"),_vm._t("description"),_c('div',{staticClass:"slide-btn"},[_vm._t("button")],2)],2)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }